<template>
  <a-form-model
    :model="form"
    ref="form"
    :rules="rules"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 20 }"
  >
    <a-form-model-item label="分类">
      <a-input v-model="subjectName" disabled />
    </a-form-model-item>
    <a-form-model-item label="列表页链接" prop="url">
      <ListInput v-model="form.url" placeholder="列表页链接" style="width: 94%"/>
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
      <a-button type="primary" @click="onSubmit">
        {{ formModel ? '修 改' : '新 增' }}
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm"> 重 置 </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { addSubjectContentApi, updateUserApi } from '@/api/TopicCrawl/CollectList'
import ListInput from '@/components/ListInput/'
export default {
  data() {
    return {
      subjectName: '',
      subjectId: '',
      form: {
        type: 'table',
        url: []
      },
      rules: {
        url: [{ required: true, message: '列表页链接必填', trigger: ['change', 'blur'] }]
      }
    }
  },

  props: ['formModel'],
  created() {
    let { subjectId, subjectName } = this.$route.query
    this.subjectName = subjectName
    this.subjectId = subjectId
  },

  methods: {
    //生产表单数据
    getPostData() {
      let postData = this.form.url.map((item) => {
        return {
          url: item,
          type: this.form.type
        }
      })
      return postData
    },

    //修改菜单
    async updateUser() {
      const res = await updateUserApi(this.getPostData())
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    //添加菜单
    async createUser() {
      const res = await addSubjectContentApi(
        { subjectId: this.subjectId, subjectContentId: '' },
        this.getPostData()
      )
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    resetForm() {
      this.$refs.form.resetFields()
    },

    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formModel) {
            this.updateUser()
          } else {
            this.createUser()
          }
        }
      })
    }
  },
  components: {
    ListInput
  },

  watch: {
    formModel: {
      handler() {},
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped></style>
